<template>
  <a-layout-footer :class="['site-footer', `site-footer--${variant}`]">
    <a-row class="footer" type="flex" align="middle">
      <a-col :xs="24" :sm="12" class="left">
        <div v-for="item in qrCodes" :key="item.title" class="qrcode">
          <img class="qrcode-image" :src="item.src" :alt="item.title" />
          <span class="title">{{ item.title }}</span>
        </div>
      </a-col>
      <a-col :xs="24" :sm="12" class="right">
        <slot name="right" />
      </a-col>
    </a-row>
    <slot name="bottom" />
  </a-layout-footer>
</template>

<script>
import qrcodeWechat from '@/assets/images/wechat-official.png'
import qrcodeEggerMiniProgram from '@/assets/images/vigour-egger-mini.png'
import qrcodeCleafMiniProgram from '@/assets/images/vigour-cleaf-mini.png'

export default {
  name: 'SiteFooter',
  props: {
    variant: {
      type: String,
      default: 'dark',
    },
    qrCodes: {
      type: Array,
      default: () => [
        { src: qrcodeWechat, title: '微信公众号' },
        { src: qrcodeEggerMiniProgram, title: '惟嘉x爱格\n微信小程序' },
        { src: qrcodeCleafMiniProgram, title: '惟嘉x可丽芙\n微信小程序' },
      ],
    },
  },
}
</script>

<style lang="stylus">
.site-footer
  padding 0
  .footer
    margin 0 auto
    text-align left
    .left
      display flex
      flex-wrap wrap
      align-items flex-start
      gap 24px
      .qrcode
        display flex
        flex-direction column
        align-items center
        width 136px
        text-align center
        .title
          display block
          margin-top 16px
          font-size 14px
          line-height 1.3
          white-space pre-line
          word-break break-word
      .qrcode-image
        width 136px
        height 136px
        object-fit contain
        display block
        background-color #fff
    .right
      text-align center
  .footer-line
    width 100%
    text-align center
  @media screen and (max-width 767px)
    .footer
      padding 24px 16px
      .left
        justify-content center
        margin-bottom 24px
      .right
        text-align center

.site-footer--dark
  background-color #1f1f1f
  .footer
    max-width 1340px
    color #999
    .right
      line-height 1.8
      > p
        text-indent 0
        display inline-block
        font-size 16px
        margin 30px 0
      .link
        width 100px
  .footer-line
    height 40px
    background-color #000
    border-top 1px #666 solid
    .title
      color #999
      font-size 14px
      line-height 40px

.site-footer--light
  background-color #d9d9d9
  .footer
    max-width 1320px
    .left
      .qrcode
        .title
          color #000
    .right
      line-height 1.5
      p
        display inline-block
        font-size 16px
        margin 20px 0
  .footer-line
    height 20px
    background-color #575757
</style>
